import { SI_ACCOUNT_REVIEW_STATE_PREFIX, SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { WI_TO_SI_AD_INTEL_ROUTES } from "app/pages/sales-intelligence/constants/wiToSiAdIntelRoutes";
import { WI_TO_SI_WEBSITE_ANALYSIS_ROUTES } from "app/pages/sales-intelligence/constants/wiToSiWebsiteAnalysisRoutes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const WI_TO_SI_ROUTES: Readonly<Record<string, string>> = Object.freeze({
    ...WI_TO_SI_AD_INTEL_ROUTES,
    ...WI_TO_SI_WEBSITE_ANALYSIS_ROUTES,
});

export const isSiStateName = (stateName: string | undefined | null): boolean =>
    !!stateName && (stateName.startsWith(`${SI_ROOT_ROUTE}-`) || stateName.startsWith(SI_ACCOUNT_REVIEW_STATE_PREFIX));

/**
 * Returns the SI mirror of a Web Intelligence state name, or `undefined` if SI does not mirror it.
 */
export const getSiMirrorState = (wiStateName: string | undefined | null): string | undefined =>
    wiStateName ? WI_TO_SI_ROUTES[wiStateName] : undefined;

/**
 * `proNavigator` state name resolver: while the current state belongs to SI, WI state names that
 * SI mirrors are replaced with their SI equivalent. Everything else is returned unchanged.
 */
export const resolveWiToSiState = (stateName: string, currentStateName: string | undefined): string =>
    isSiStateName(currentStateName) ? (getSiMirrorState(stateName) ?? stateName) : stateName;

let deregisterResolver: (() => void) | undefined;

/**
 * Called from the SI root state's `onEnter`, which runs before any SI page renders, so hrefs built
 * during the first render already point at SI states.
 */
export const registerWiToSiStateResolver = (): void => {
    deregisterResolver?.();
    deregisterResolver = proNavigator.registerStateNameResolver(resolveWiToSiState);
};

export const deregisterWiToSiStateResolver = (): void => {
    deregisterResolver?.();
    deregisterResolver = undefined;
};
